import { useMemo, type FC } from 'react';

import { RenderingProvider, useCms } from '@eneco/cms';
import { I18nProvider } from '@eneco/i18n';

import { FilterProvider } from './InspirationAdviceFilter.context';
import { InspirationAdviceFilterView } from './InspirationAdviceFilter.view';

interface InspirationAdviceFilterProps {
  fields?: unknown;
  params?: Record<string, string>;
  placeholders?: Record<string, unknown[]>;
  componentName?: string;
  uid?: string;
}

/** Registered in the containers' `cmsComponents.ts`, where the CMS lane's `Placeholder` supplies the rendering. */
export const InspirationAdviceFilterInner: FC = () => {
  return (
    <I18nProvider dictionary={locale => import(`./content/${locale}.json`)}>
      <FilterProvider>
        <InspirationAdviceFilterView />
      </FilterProvider>
    </I18nProvider>
  );
};

/** The Sitecore lane's entry, which bridges the JSS props it is handed into an `@eneco/cms` rendering. */
const InspirationAdviceFilter: FC<InspirationAdviceFilterProps> = ({
  fields,
  params,
  placeholders,
  componentName,
  uid,
}) => {
  const { adapter } = useCms();
  const rendering = useMemo(
    () =>
      adapter.toRendering({
        componentName: componentName ?? 'InspirationAdviceFilter',
        uid,
        fields,
        params,
        placeholders,
      }),
    [adapter, fields, params, placeholders, componentName, uid],
  );

  return (
    <RenderingProvider rendering={rendering}>
      <InspirationAdviceFilterInner />
    </RenderingProvider>
  );
};

export default InspirationAdviceFilter;
